import { PIEVE_CAPABILITY_DEFAULTS } from './capabilityDefaults.js';

const mergeCapabilityLayers = ({ roleBlob, userBlob } = {}) => {
  return deepMerge(PIEVE_CAPABILITY_DEFAULTS, roleBlob, userBlob);
};

const deepMerge = (defaultsValue, roleValue, userValue) => {
  if (isLeaf(defaultsValue) && isLeaf(roleValue) && isLeaf(userValue)) {
    return userValue ?? roleValue ?? defaultsValue;
  }

  const defaultsObject = isObject(defaultsValue) ? defaultsValue : {};
  const roleObject = isObject(roleValue) ? roleValue : {};
  const userObject = isObject(userValue) ? userValue : {};
  const allKeys = new Set([...Object.keys(defaultsObject), ...Object.keys(roleObject), ...Object.keys(userObject)]);
  const nextValue = {};

  for (const key of allKeys) {
    nextValue[key] = deepMerge(defaultsObject[key], roleObject[key], userObject[key]);
  }

  return nextValue;
};

const isLeaf = (value) => {
  return value === undefined || value === null || typeof value === 'string';
};

const isObject = (value) => {
  return value !== null && value !== undefined && typeof value === 'object' && !Array.isArray(value);
};

export default mergeCapabilityLayers;
